import * as React from 'react'
import { v4 as uuidv4 } from 'uuid'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import { appdata } from '../internalModules'
import IconButton from '@mui/material/IconButton'
import ClearIcon from '@mui/icons-material/Clear'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import UIAssemblyLayerOrderHorizontal from './UIAssemblyLayerOrderHorizontal'
import { ListItemButton, ListItemIcon, Tooltip } from '@mui/material'
import {ALayer, buckets } from '../internalModules'
import UILayerDialog from './UILayerDialog'
import UIAssemblyLayerOrder from './UIAssemblyLayerOrder'
import UILayerIcon from './UILayerIcon'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

type Props = {
  assemblyGuid: string,
  bucket: string,
  index: number,
  removeAssemblyLayer: Function,
  updateApp: Function
}

export default function UIAssemblyRow2({assemblyGuid, bucket,
index, removeAssemblyLayer, updateApp}: Props){
  
  const assembly = appdata.getWallType(assemblyGuid)
  const layers = assembly.getLayers(bucket)
  const layer = layers[index]
  let name = ''
  if(layer){
    name = layer.name(assembly)
  }

  const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id: layer.id, animateLayoutChanges: ()=>false})

  const [dialogOpen, setDialogOpen] = React.useState(false)

  if(layer === undefined){
    return(<></>)
  }

  const toggleDialogOpen = (open: boolean) => (event: React.MouseEvent) => {
    setDialogOpen(open)
  }

  function acceptDialog(layer: ALayer, mode: string, layerBucket: string, layerIndex: number){
    //update the layer
    assembly.updateLayer(layerBucket, layer, layerIndex)
    updateApp()
    toggleDialogOpen(false)
  }

  function handleRemove(){
    removeAssemblyLayer(bucket, index)
  }

  function reorderLayer(bucket: string, fromIndex: number, toIndex: number){
    assembly.reorderLayer(bucket, fromIndex, toIndex)
    updateApp()
  }

  const style = {
    transition,
    transform: CSS.Transform.toString(transform)
  }

  return (
    <div ref={setNodeRef} style={style}>
      <ListItem key={layer.id} sx={{pl: 0, py: 0, pr: 0}}
        dense={true}
        divider={true}
      >
        { bucket !== buckets.column ?
          <Tooltip arrow followCursor title='Drag to reorder'>
            <DragIndicatorIcon {...listeners} {...attributes} className='drag-handle' fontSize='medium' color='disabled' />
          </Tooltip>
          :<></>
        }
        
        <Tooltip arrow followCursor title='Edit layer'>
          <ListItemButton onClick={toggleDialogOpen(true)} disableRipple>
            <ListItemIcon>
              <UILayerIcon layerKind={layer.kind} assembly={assembly}/>
            </ListItemIcon>
            <ListItemText className='layername' primary={name}
              primaryTypographyProps={{
                fontSize: 14,
                style: {
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }
              }}
            />
          </ListItemButton>
        </Tooltip>
        
        <Tooltip arrow followCursor title='Remove layer'>
          <IconButton aria-label='remove layer' onClick={handleRemove} sx={{borderRadius: 0}}>
            <ClearIcon fontSize='small' />
          </IconButton>
        </Tooltip>
        
        <UILayerDialog key={uuidv4()} assemblyGuid={assemblyGuid} bucket={bucket}
          index={index} isOpen={dialogOpen} 
          closeDialog={toggleDialogOpen(false)}
          acceptDialog={acceptDialog}/>
      </ListItem>
    </div>  
  )
}